import React, { useEffect, useState } from "react";
import './header.css'
import earthmaalogo from "../assets/images/earthmaalogo.webp";
import earthmaalogoblue from "../assets/images/earthmaalogo(blue).webp";
import { Link, useLocation } from "react-router-dom";
const Header = () => {
    const [active, setActive] = useState(false);

  const { pathname } = useLocation();
  const [logo, setLogo] = useState(earthmaalogo); // default logo

  useEffect(() => {
   
    const handleScroll = () => {
      if (pathname === "/" || window.scrollY > 100) {
        setLogo(earthmaalogo);
      } else {
        setLogo(earthmaalogoblue);
      }

    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // run once on load

    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);



  const myFunction = () => {
    setActive(!active); // toggle state
  };
  return (
    <header class="header">
     
         <Link to="/" style={{color:'white',textDecoration:'none'}} aria-label="Go to Home">
         <div className="logo">
        <h2>DEMO<sup>®</sup></h2> 
    {/* <img src="" alt="earthmaa-logo" id="biglogo" width={150} height={70}/> */}
      </div>
      </Link>
   

  
      <nav className={active ? "nav openNav" : "nav"}>
       
         
         <Link to="/productlist" onClick={myFunction}>PRODUCTS</Link>
        <Link to="/about" onClick={myFunction}>ABOUT US</Link>
         <Link to="blog" onClick={myFunction}>BLOG</Link>
       <Link to="/contact" onClick={myFunction}>CONTACT</Link>
      
      </nav>

    
      <div className="tool-icons">
    
          <Link to="productList">
          <i className="material-icons">&#xe8b6;</i>
          </Link>
      
        <Link to="productList"><i className="material-icons">&#xe8cc;</i></Link>
      

    
         <a class="opennavbtn">
          <span style={{ fontSize: "20px" }} onClick={myFunction} >
            &#x2630;
          </span>
        </a>
      </div>

      
    </header>
  );
};

export default Header;
